<script lang="ts" setup>
  import { NEED_HELP_BUTTON_TEST_ID } from './NeedHelpButtonQC.constants'
  import IconQC from '@qicgroupdoha/qic-connect-ds/components/IconQC'
  import CellQC from '@qicgroupdoha/qic-connect-ds/components/CellQC'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'

  interface Emits {
    (e: 'click'): void
  }
  const emit = defineEmits<Emits>()
</script>

<template>
  <button
    class="need-help-button-qc text-medium"
    :data-test="NEED_HELP_BUTTON_TEST_ID"
    @click="emit('click')"
  >
    <CellQC padding-block="spacing-2">
      <template #title>
        <WrapperQC direction="row" gap="var(--spacing-3)">
          <IconQC
            class="need-help-button-qc__icon"
            name="chat"
            color="var(--colorIcnSrfTertiary)"
          />
          {{ $t('qic_contact_us') }}
        </WrapperQC>
      </template>
    </CellQC>
  </button>
</template>

<style lang="scss" scoped>
  .need-help-button-qc {
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover,
    &:active {
      opacity: 0.9;
    }
  }
</style>
